"use client";
import { useState } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";

import { Disclosure } from "@headlessui/react";
import IconArrow from "assets/svg/chevron-down.svg";

import styles from "./styles.module.css";

const InnerBox = ({ children, title, subItem, isDropdownView, isHidden, titleClasses, contentClass }) => {
  const [isOpened, setIsOpened] = useState(isHidden || false);
  const wrapperClasses = classNames({
    [styles.wrapper]: true,
  });

  const iconClasses = classNames({
    [styles.iconWrap]: true,
    [styles.iconWrapOpened]: isOpened,
  });

  const titleClass = classNames({
    [styles.title]: !subItem,
    [styles.subTitle]: subItem,
    [titleClasses]: titleClasses,
  });

  const contentClasses = classNames({
    [styles.content]: true,
    [styles.contentOpened]: isOpened,
    [styles.contentIsStatic]: !isDropdownView,
    [contentClass]: contentClass,
  });
  const handleButton = () => {
    /* const openedEl = document.querySelector("[data-headlessui-state='open']");
    if (openedEl && !isOpened && isDropdownView) openedEl.click(); */
    setIsOpened(!isOpened);
  };

  return (
    <Disclosure defaultOpen={isHidden} className={wrapperClasses}>
      <>
        <Disclosure.Button as="span" className={styles.header} onClick={handleButton}>
          <span className={titleClass}>{title}</span>
          {isDropdownView && !subItem && (
            <div className={iconClasses}>
              <IconArrow />
            </div>
          )}
          {isDropdownView && subItem && <div className={styles.subIcon}>{isOpened ? "-" : "+"}</div>}
        </Disclosure.Button>
        <div className={contentClasses}>{children}</div>
      </>
    </Disclosure>
  );
};

InnerBox.propTypes = {
  children: PropTypes.any,
  title: PropTypes.any,
  isDropdownView: PropTypes.bool,
  subItem: PropTypes.bool,
  isHidden: PropTypes.bool,
  titleClasses: PropTypes.string,
  contentClass: PropTypes.string,
};

export default InnerBox;
